module.exports = __webpack_public_path__ + "static/preset-column-3-5a0333948f83b71395dd83c56780e5db.png";